import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import RightModalLayout from '../layouts/Modal/RightModalLayout';
import { SIDEBAR_ACTIONS } from '../../constants/actionsConstants';

const IntegrationVideo = ({ title, videoId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('integrations');

  return (
    <RightModalLayout
      title={title}
      submitAction={() => dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR })}
      submitLabel={t('videoModalButton')}
    >
      <div className="tw-relative tw-w-full tw-pt-[56.25%]">
        <iframe
          className="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full"
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video"
          allowFullScreen
        />
      </div>
    </RightModalLayout>
  );
};

export default IntegrationVideo;
